import { useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useSession } from '@/components/layout/AppShell';

const GITHUB_APP_SLUG = (import.meta as ImportMeta & { env: Record<string, string> }).env.VITE_GITHUB_APP_SLUG ?? '';

export function IntegrationsPage() {
  const [params] = useSearchParams();
  const installed = params.get('installed') === '1';
  const error = params.get('error');
  const { org } = useSession();

  const installUrl = GITHUB_APP_SLUG
    ? `https://github.com/apps/${GITHUB_APP_SLUG}/installations/new?state=${encodeURIComponent(org.id)}`
    : null;

  return (
    <div className="max-w-4xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Integrations</h1>
        <p className="text-sm text-muted-foreground">
          Connect Pure to your git host so we can clone private repos at compile time.
        </p>
      </div>

      {installed && (
        <Alert variant="success">
          <AlertDescription>GitHub App installed successfully.</AlertDescription>
        </Alert>
      )}
      {error && (
        <Alert variant="destructive">
          <AlertDescription>GitHub install failed: {error}</AlertDescription>
        </Alert>
      )}

      <Card>
        <CardHeader>
          <CardTitle>GitHub</CardTitle>
          <CardDescription>
            Install the Pure GitHub App to grant access to selected repositories. Tokens are
            short-lived (1h), auto-rotating, and scoped to just the repos you choose.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {installUrl ? (
            <a
              href={installUrl}
              className="inline-flex items-center h-9 px-4 py-2 rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90"
            >
              Install Pure on GitHub
            </a>
          ) : (
            <Alert>
              <AlertDescription>
                GitHub App is not configured on this deployment. Set{' '}
                <code>VITE_GITHUB_APP_SLUG</code> in the frontend build environment.
              </AlertDescription>
            </Alert>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>GitLab</CardTitle>
          <CardDescription>Coming soon.</CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
